// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { createUserForGuest } from "@eisinc/App/Services/GuestAccountService";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const CreateAccount: any = async (props: any) => {
    const result = await createUserForGuest();
    props.apiResult = result;
};

export const ExecuteOnErrorCallback: any = (props: any) => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.();
    }
};

export const ExecuteOnSuccessCallback: any = (props: any) => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [CreateAccount, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const createAccount = createHandlerChainRunnerOptionalParameter(chain, {}, "CreateAccount");
export default createAccount;
